import { createEntityAdapter, EntityState } from '@ngrx/entity';

import { OccupationCard } from '@cpd-app/generated';

export const favoriteOccupationsFeatureKey = 'favoriteOccupations';

export const favoriteOccupationsStateAdapter =
  createEntityAdapter<OccupationCard>({
    selectId: (favoriteOccupation: OccupationCard) =>
      favoriteOccupation.onetCode + '_' + (favoriteOccupation.jobId ?? 0),
    sortComparer: false
  });

export type FavoriteOccupationsState = EntityState<OccupationCard>;

export const initialFavoriteOccupationsState: FavoriteOccupationsState =
  favoriteOccupationsStateAdapter.getInitialState({});

export const { selectAll, selectEntities, selectIds, selectTotal } =
  favoriteOccupationsStateAdapter.getSelectors();
